import { MessageTemplateEditComponent } from './message-template/dialogs/message-template-edit.component';
import { MessageTemplateComponent } from './message-template/message-template.component';
import { MemberLogsComponent } from './member-logs/member-logs.component';
import { OperatorDialogComponent } from './operators/dialogs/operator-profile.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OperatorComponent } from './operators/operator.component';
import { SuperuserReportsWinloseComponent } from './subcomponents/superuser-reports-winlose/superuser-reports-winlose.component';
import { SuperuserReportsWinloseFullComponent } from './subcomponents/superuser-reports-winlose-full/superuser-reports-winlose-full.component';
import { SuperuserReportsMemberinoutComponent } from './subcomponents/superuser-reports-memberinout/superuser-reports-memberinout.component';
import { SuperuserReportsMemberaccountComponent } from './subcomponents/superuser-reports-memberaccount/superuser-reports-memberaccount.component';
import { SuperuserCashflowComponent } from './subcomponents/superuser-cashflow/superuser-cashflow.component';
import { OperatorLogsComponent } from './operator-logs/operator-logs.component';
import { SystemErrorLogComponent } from './system-error-logs/system-error-logs.component';
import { SystemMaintenanceComponent } from './system-maintenance/system-maintenance.component';
import { SystemMaintenanceEditComponent } from './system-maintenance/dialog/system-maintenance-edit.component';
import { IpWhitelistingComponent } from './ip-whitelisting/ip-whitelisting.component';
import { IpWhitelistingEditComponent } from './ip-whitelisting/dialog/ip-whitelisting-edit.component';
import { SystemSettingComponent } from './system-setting/system-setting.component';
import { ApiKeySettingComponent } from './api-key-setting/api-key-setting.component';
import { ApiKeySettingEditComponent } from './api-key-setting/dialog/api-key-setting-edit.component';

import { SiteDomainComponent } from './site-domain/site-domain.component';
import { SiteDomainEditComponent } from './site-domain/dialog/site-domain-edit.component';
import { AuditsComponent } from './audits/audits.component';
import { ApplicationPermissionsComponent } from './application-permissions/application-permissions.component';
import { ApplicationPermissionEditDialogComponent } from './application-permissions/dialogs/application-permission-edit.component';
import { ApplicationRoleComponent } from './application-roles/application-role.component';
import { ApplicationRoleEditDialogComponent } from './application-roles/dialogs/application-role-edit.component';
import { ApplicationRolePermissionLayerComponent } from './application-roles/permission-layer/application-role-permission-layer.component';
import { ShowAffiliateRemarkComponent } from './message-template/dialogs/show-affiliate-remark/show-affiliate-remark.component';
import { AffiliateMessageTemplateEditComponent } from './message-template/dialogs/affiliate-message-template-edit/affiliate-message-template-edit.component';
import { DomainURLComponent } from './domain-url/domain-url.component';
import { DomainURLEditComponent } from './domain-url/dialog/domain-url-edit.component';
import { AppPermissionKeys } from '@core/models/app-permissions.model';

const routes: Routes = [
  {
    path: 'system-error-logs',
    component: SystemErrorLogComponent,
    data: { permissions: AppPermissionKeys.view_system_error_log }
  },
  {
    path: 'operator-logs',
    component: OperatorLogsComponent,
    data: { permissions: AppPermissionKeys.view_operator_log }
  },
  {
    path: 'member-logs',
    component: MemberLogsComponent,
    data: { permissions: AppPermissionKeys.view_member_log }
  },
  {
    path: 'audits',
    component: AuditsComponent,
    data: { permissions: AppPermissionKeys.view_audit_log }
  },
  {
    path: 'system-maintenance',
    component: SystemMaintenanceComponent,
    data: { permissions: AppPermissionKeys.view_system_maintenance }
  },
  {
    path: 'system-setting',
    component: SystemSettingComponent,
  },
  {
    path: 'site-domain',
    component: SiteDomainComponent,
    data: { permissions: AppPermissionKeys.view_site_domain }
  },
  {
    path: 'api-key-setting',
    component: ApiKeySettingComponent,
    data: { permissions: AppPermissionKeys.view_api_key_settings }
  },
  {
    path: 'domain-url',
    component: DomainURLComponent,
    data: { permissions: AppPermissionKeys.view_domain_url }
  },
  {
    path: 'message-template',
    component: MessageTemplateComponent,
    data: { permissions: [AppPermissionKeys.view_message_template_list, AppPermissionKeys.view_affiliate_message_template_list] }
  },
  {
    path: 'operators',
    component: OperatorComponent,
    data: { permissions: AppPermissionKeys.view_operators_list }
  },
  {
    path: 'ip-whitelisting',
    component: IpWhitelistingComponent,
    data: { permissions: AppPermissionKeys.view_ip_whitelist }
  },
  {
    path: 'reports',
    children: [
      {
        path: 'winlose-simple',
        component: SuperuserReportsWinloseComponent
      },
      {
        path: 'winlose-full',
        component: SuperuserReportsWinloseFullComponent
      },
      {
        path: 'member-inout',
        component: SuperuserReportsMemberinoutComponent
      },
      {
        path: 'member-account',
        component: SuperuserReportsMemberaccountComponent
      }
    ]
  },
  {
    path: 'cashflow',
    component: SuperuserCashflowComponent
  },
  {
    path: 'application-permissions',
    component: ApplicationPermissionsComponent,
    data: { permissions: AppPermissionKeys.view_permissions_list }
  },
  {
    path: 'application-roles',
    component: ApplicationRoleComponent,
    data: { permissions: AppPermissionKeys.app_role_view_roles_list }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  entryComponents: [
    OperatorDialogComponent,
    MessageTemplateEditComponent,
    SystemMaintenanceEditComponent,
    IpWhitelistingEditComponent,
    ApiKeySettingEditComponent,
    SiteDomainEditComponent,
    ApplicationPermissionEditDialogComponent,
    ApplicationRoleEditDialogComponent,
    ApplicationRolePermissionLayerComponent,
    ShowAffiliateRemarkComponent,
    AffiliateMessageTemplateEditComponent,
    DomainURLEditComponent
  ]
})
export class SuperuserRoutingModule { }
